// @flow
import { useRef, useEffect } from 'react';

export function usePrevious<T>(value: T, defaultValue?: T | null = null): T | null {
  const ref = useRef<T | null>(defaultValue);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export default usePrevious;
